import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../../../../contexts/LocaleContext';
import { LINKS } from '../../../../config/links';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useLocale();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="ainstein-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{t('footerAInsteinTitle')}</h3>
            <p>{t('footerAInsteinDescription')}</p>
            <div className="social-links">
              <a href={LINKS.apps.ainstein.social.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href={LINKS.apps.ainstein.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>{t('footerLegalTitle')}</h4>
            <ul>
              <li><Link to="/ainstein/privacy">{t('footerPrivacyPolicy')}</Link></li>
              <li><Link to="/ainstein/terms">{t('footerTermsOfService')}</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} {t('footerAInsteinTitle')}. {t('footerAllRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
